/**
 * Function performs common check used across the code:
 * either the selected period on two products is the same or not.
 *
 * @param {object} productA
 * @param {object} productB
 * @return {boolean}
 */
export default (productA, productB) => {
    return productA?.period?.interval !== productB?.period?.interval
        || productA?.period?.billing_period !== productB?.period?.billing_period
}
